/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as HomeRouteImport } from './routes/home'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SampleIndexRouteImport } from './routes/sample/index'
import { Route as SamplePostsRouteImport } from './routes/sample/posts'
import { Route as SampleGroupBRouteImport } from './routes/sample/group-b'
import { Route as SampleGroupARouteImport } from './routes/sample/group-a'
import { Route as SampleBasicRouteImport } from './routes/sample/basic'
import { Route as SampleLayoutRouteImport } from './routes/sample/_layout'
import { Route as SampleProductsRouteRouteImport } from './routes/sample/products/route'
import { Route as SampleProductsIndexRouteImport } from './routes/sample/products/index'
import { Route as SamplePostsIndexRouteImport } from './routes/sample/posts/index'
import { Route as SampleProductsProductIdRouteImport } from './routes/sample/products/$productId'
import { Route as SamplePostsPostIdRouteImport } from './routes/sample/posts/$postId'
import { Route as SampleFilesSplatRouteImport } from './routes/sample/files.$'
import { Route as SampleLayoutBRouteImport } from './routes/sample/_layout/b'
import { Route as SampleLayoutARouteImport } from './routes/sample/_layout/a'
import { Route as SampleProductsProductIdDetailRouteImport } from './routes/sample/products_.$productId.detail'
import { Route as SamplePostsPostIdEditRouteImport } from './routes/sample/posts/$postId.edit'

const SampleRouteImport = createFileRoute('/sample')()

const SampleRoute = SampleRouteImport.update({
  id: '/sample',
  path: '/sample',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SampleIndexRoute = SampleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SampleRoute,
} as any)
const SamplePostsRoute = SamplePostsRouteImport.update({
  id: '/posts',
  path: '/posts',
  getParentRoute: () => SampleRoute,
} as any)
const SampleGroupBRoute = SampleGroupBRouteImport.update({
  id: '/group-b',
  path: '/group-b',
  getParentRoute: () => SampleRoute,
} as any)
const SampleGroupARoute = SampleGroupARouteImport.update({
  id: '/group-a',
  path: '/group-a',
  getParentRoute: () => SampleRoute,
} as any)
const SampleBasicRoute = SampleBasicRouteImport.update({
  id: '/basic',
  path: '/basic',
  getParentRoute: () => SampleRoute,
} as any)
const SampleLayoutRoute = SampleLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => SampleRoute,
} as any)
const SampleProductsRouteRoute = SampleProductsRouteRouteImport.update({
  id: '/sample/products',
  path: '/sample/products',
  getParentRoute: () => rootRouteImport,
} as any)
const SampleProductsIndexRoute = SampleProductsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SampleProductsRouteRoute,
} as any)
const SamplePostsIndexRoute = SamplePostsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SamplePostsRoute,
} as any)
const SampleProductsProductIdRoute = SampleProductsProductIdRouteImport.update({
  id: '/$productId',
  path: '/$productId',
  getParentRoute: () => SampleProductsRouteRoute,
} as any)
const SamplePostsPostIdRoute = SamplePostsPostIdRouteImport.update({
  id: '/$postId',
  path: '/$postId',
  getParentRoute: () => SamplePostsRoute,
} as any)
const SampleFilesSplatRoute = SampleFilesSplatRouteImport.update({
  id: '/files/$',
  path: '/files/$',
  getParentRoute: () => SampleRoute,
} as any)
const SampleLayoutBRoute = SampleLayoutBRouteImport.update({
  id: '/b',
  path: '/b',
  getParentRoute: () => SampleLayoutRoute,
} as any)
const SampleLayoutARoute = SampleLayoutARouteImport.update({
  id: '/a',
  path: '/a',
  getParentRoute: () => SampleLayoutRoute,
} as any)
const SampleProductsProductIdDetailRoute =
  SampleProductsProductIdDetailRouteImport.update({
    id: '/products_/$productId/detail',
    path: '/products/$productId/detail',
    getParentRoute: () => SampleRoute,
  } as any)
const SamplePostsPostIdEditRoute = SamplePostsPostIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => SamplePostsPostIdRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/home': typeof HomeRoute
  '/settings': typeof SettingsRoute
  '/sample/products': typeof SampleProductsRouteRouteWithChildren
  '/sample': typeof SampleLayoutRouteWithChildren
  '/sample/basic': typeof SampleBasicRoute
  '/sample/group-a': typeof SampleGroupARoute
  '/sample/group-b': typeof SampleGroupBRoute
  '/sample/posts': typeof SamplePostsRouteWithChildren
  '/sample/': typeof SampleIndexRoute
  '/sample/a': typeof SampleLayoutARoute
  '/sample/b': typeof SampleLayoutBRoute
  '/sample/files/$': typeof SampleFilesSplatRoute
  '/sample/posts/$postId': typeof SamplePostsPostIdRouteWithChildren
  '/sample/products/$productId': typeof SampleProductsProductIdRoute
  '/sample/posts/': typeof SamplePostsIndexRoute
  '/sample/products/': typeof SampleProductsIndexRoute
  '/sample/posts/$postId/edit': typeof SamplePostsPostIdEditRoute
  '/sample/products/$productId/detail': typeof SampleProductsProductIdDetailRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/home': typeof HomeRoute
  '/settings': typeof SettingsRoute
  '/sample': typeof SampleIndexRoute
  '/sample/basic': typeof SampleBasicRoute
  '/sample/group-a': typeof SampleGroupARoute
  '/sample/group-b': typeof SampleGroupBRoute
  '/sample/a': typeof SampleLayoutARoute
  '/sample/b': typeof SampleLayoutBRoute
  '/sample/files/$': typeof SampleFilesSplatRoute
  '/sample/posts/$postId': typeof SamplePostsPostIdRouteWithChildren
  '/sample/products/$productId': typeof SampleProductsProductIdRoute
  '/sample/posts': typeof SamplePostsIndexRoute
  '/sample/products': typeof SampleProductsIndexRoute
  '/sample/posts/$postId/edit': typeof SamplePostsPostIdEditRoute
  '/sample/products/$productId/detail': typeof SampleProductsProductIdDetailRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/home': typeof HomeRoute
  '/settings': typeof SettingsRoute
  '/sample/products': typeof SampleProductsRouteRouteWithChildren
  '/sample': typeof SampleRouteWithChildren
  '/sample/_layout': typeof SampleLayoutRouteWithChildren
  '/sample/basic': typeof SampleBasicRoute
  '/sample/group-a': typeof SampleGroupARoute
  '/sample/group-b': typeof SampleGroupBRoute
  '/sample/posts': typeof SamplePostsRouteWithChildren
  '/sample/': typeof SampleIndexRoute
  '/sample/_layout/a': typeof SampleLayoutARoute
  '/sample/_layout/b': typeof SampleLayoutBRoute
  '/sample/files/$': typeof SampleFilesSplatRoute
  '/sample/posts/$postId': typeof SamplePostsPostIdRouteWithChildren
  '/sample/products/$productId': typeof SampleProductsProductIdRoute
  '/sample/posts/': typeof SamplePostsIndexRoute
  '/sample/products/': typeof SampleProductsIndexRoute
  '/sample/posts/$postId/edit': typeof SamplePostsPostIdEditRoute
  '/sample/products_/$productId/detail': typeof SampleProductsProductIdDetailRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/home'
    | '/settings'
    | '/sample/products'
    | '/sample'
    | '/sample/basic'
    | '/sample/group-a'
    | '/sample/group-b'
    | '/sample/posts'
    | '/sample/'
    | '/sample/a'
    | '/sample/b'
    | '/sample/files/$'
    | '/sample/posts/$postId'
    | '/sample/products/$productId'
    | '/sample/posts/'
    | '/sample/products/'
    | '/sample/posts/$postId/edit'
    | '/sample/products/$productId/detail'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/home'
    | '/settings'
    | '/sample'
    | '/sample/basic'
    | '/sample/group-a'
    | '/sample/group-b'
    | '/sample/a'
    | '/sample/b'
    | '/sample/files/$'
    | '/sample/posts/$postId'
    | '/sample/products/$productId'
    | '/sample/posts'
    | '/sample/products'
    | '/sample/posts/$postId/edit'
    | '/sample/products/$productId/detail'
  id:
    | '__root__'
    | '/'
    | '/home'
    | '/settings'
    | '/sample/products'
    | '/sample'
    | '/sample/_layout'
    | '/sample/basic'
    | '/sample/group-a'
    | '/sample/group-b'
    | '/sample/posts'
    | '/sample/'
    | '/sample/_layout/a'
    | '/sample/_layout/b'
    | '/sample/files/$'
    | '/sample/posts/$postId'
    | '/sample/products/$productId'
    | '/sample/posts/'
    | '/sample/products/'
    | '/sample/posts/$postId/edit'
    | '/sample/products_/$productId/detail'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HomeRoute: typeof HomeRoute
  SettingsRoute: typeof SettingsRoute
  SampleProductsRouteRoute: typeof SampleProductsRouteRouteWithChildren
  SampleRoute: typeof SampleRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sample': {
      id: '/sample'
      path: '/sample'
      fullPath: '/sample'
      preLoaderRoute: typeof SampleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sample/': {
      id: '/sample/'
      path: '/'
      fullPath: '/sample/'
      preLoaderRoute: typeof SampleIndexRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/posts': {
      id: '/sample/posts'
      path: '/posts'
      fullPath: '/sample/posts'
      preLoaderRoute: typeof SamplePostsRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/group-b': {
      id: '/sample/group-b'
      path: '/group-b'
      fullPath: '/sample/group-b'
      preLoaderRoute: typeof SampleGroupBRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/group-a': {
      id: '/sample/group-a'
      path: '/group-a'
      fullPath: '/sample/group-a'
      preLoaderRoute: typeof SampleGroupARouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/basic': {
      id: '/sample/basic'
      path: '/basic'
      fullPath: '/sample/basic'
      preLoaderRoute: typeof SampleBasicRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/_layout': {
      id: '/sample/_layout'
      path: '/sample'
      fullPath: '/sample'
      preLoaderRoute: typeof SampleLayoutRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/products': {
      id: '/sample/products'
      path: '/sample/products'
      fullPath: '/sample/products'
      preLoaderRoute: typeof SampleProductsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sample/products/': {
      id: '/sample/products/'
      path: '/'
      fullPath: '/sample/products/'
      preLoaderRoute: typeof SampleProductsIndexRouteImport
      parentRoute: typeof SampleProductsRouteRoute
    }
    '/sample/posts/': {
      id: '/sample/posts/'
      path: '/'
      fullPath: '/sample/posts/'
      preLoaderRoute: typeof SamplePostsIndexRouteImport
      parentRoute: typeof SamplePostsRoute
    }
    '/sample/products/$productId': {
      id: '/sample/products/$productId'
      path: '/$productId'
      fullPath: '/sample/products/$productId'
      preLoaderRoute: typeof SampleProductsProductIdRouteImport
      parentRoute: typeof SampleProductsRouteRoute
    }
    '/sample/posts/$postId': {
      id: '/sample/posts/$postId'
      path: '/$postId'
      fullPath: '/sample/posts/$postId'
      preLoaderRoute: typeof SamplePostsPostIdRouteImport
      parentRoute: typeof SamplePostsRoute
    }
    '/sample/files/$': {
      id: '/sample/files/$'
      path: '/files/$'
      fullPath: '/sample/files/$'
      preLoaderRoute: typeof SampleFilesSplatRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/_layout/b': {
      id: '/sample/_layout/b'
      path: '/b'
      fullPath: '/sample/b'
      preLoaderRoute: typeof SampleLayoutBRouteImport
      parentRoute: typeof SampleLayoutRoute
    }
    '/sample/_layout/a': {
      id: '/sample/_layout/a'
      path: '/a'
      fullPath: '/sample/a'
      preLoaderRoute: typeof SampleLayoutARouteImport
      parentRoute: typeof SampleLayoutRoute
    }
    '/sample/products_/$productId/detail': {
      id: '/sample/products_/$productId/detail'
      path: '/products/$productId/detail'
      fullPath: '/sample/products/$productId/detail'
      preLoaderRoute: typeof SampleProductsProductIdDetailRouteImport
      parentRoute: typeof SampleRoute
    }
    '/sample/posts/$postId/edit': {
      id: '/sample/posts/$postId/edit'
      path: '/edit'
      fullPath: '/sample/posts/$postId/edit'
      preLoaderRoute: typeof SamplePostsPostIdEditRouteImport
      parentRoute: typeof SamplePostsPostIdRoute
    }
  }
}

interface SampleProductsRouteRouteChildren {
  SampleProductsProductIdRoute: typeof SampleProductsProductIdRoute
  SampleProductsIndexRoute: typeof SampleProductsIndexRoute
}

const SampleProductsRouteRouteChildren: SampleProductsRouteRouteChildren = {
  SampleProductsProductIdRoute: SampleProductsProductIdRoute,
  SampleProductsIndexRoute: SampleProductsIndexRoute,
}

const SampleProductsRouteRouteWithChildren =
  SampleProductsRouteRoute._addFileChildren(SampleProductsRouteRouteChildren)

interface SampleLayoutRouteChildren {
  SampleLayoutARoute: typeof SampleLayoutARoute
  SampleLayoutBRoute: typeof SampleLayoutBRoute
}

const SampleLayoutRouteChildren: SampleLayoutRouteChildren = {
  SampleLayoutARoute: SampleLayoutARoute,
  SampleLayoutBRoute: SampleLayoutBRoute,
}

const SampleLayoutRouteWithChildren = SampleLayoutRoute._addFileChildren(
  SampleLayoutRouteChildren,
)

interface SamplePostsPostIdRouteChildren {
  SamplePostsPostIdEditRoute: typeof SamplePostsPostIdEditRoute
}

const SamplePostsPostIdRouteChildren: SamplePostsPostIdRouteChildren = {
  SamplePostsPostIdEditRoute: SamplePostsPostIdEditRoute,
}

const SamplePostsPostIdRouteWithChildren =
  SamplePostsPostIdRoute._addFileChildren(SamplePostsPostIdRouteChildren)

interface SamplePostsRouteChildren {
  SamplePostsPostIdRoute: typeof SamplePostsPostIdRouteWithChildren
  SamplePostsIndexRoute: typeof SamplePostsIndexRoute
}

const SamplePostsRouteChildren: SamplePostsRouteChildren = {
  SamplePostsPostIdRoute: SamplePostsPostIdRouteWithChildren,
  SamplePostsIndexRoute: SamplePostsIndexRoute,
}

const SamplePostsRouteWithChildren = SamplePostsRoute._addFileChildren(
  SamplePostsRouteChildren,
)

interface SampleRouteChildren {
  SampleLayoutRoute: typeof SampleLayoutRouteWithChildren
  SampleBasicRoute: typeof SampleBasicRoute
  SampleGroupARoute: typeof SampleGroupARoute
  SampleGroupBRoute: typeof SampleGroupBRoute
  SamplePostsRoute: typeof SamplePostsRouteWithChildren
  SampleIndexRoute: typeof SampleIndexRoute
  SampleFilesSplatRoute: typeof SampleFilesSplatRoute
  SampleProductsProductIdDetailRoute: typeof SampleProductsProductIdDetailRoute
}

const SampleRouteChildren: SampleRouteChildren = {
  SampleLayoutRoute: SampleLayoutRouteWithChildren,
  SampleBasicRoute: SampleBasicRoute,
  SampleGroupARoute: SampleGroupARoute,
  SampleGroupBRoute: SampleGroupBRoute,
  SamplePostsRoute: SamplePostsRouteWithChildren,
  SampleIndexRoute: SampleIndexRoute,
  SampleFilesSplatRoute: SampleFilesSplatRoute,
  SampleProductsProductIdDetailRoute: SampleProductsProductIdDetailRoute,
}

const SampleRouteWithChildren =
  SampleRoute._addFileChildren(SampleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HomeRoute: HomeRoute,
  SettingsRoute: SettingsRoute,
  SampleProductsRouteRoute: SampleProductsRouteRouteWithChildren,
  SampleRoute: SampleRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
